import { render } from "./GuiSubscriptionTariffSelect.vue?vue&type=template&id=3c221a7b"
import script from "./GuiSubscriptionTariffSelect.vue?vue&type=script&lang=js"
export * from "./GuiSubscriptionTariffSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__